/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { triggersList } from "../funcs/triggersList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListTriggerInstancesResult } from "../models/components/listtriggerinstancesresult.js";
import {
  ListTriggerInstancesRequest,
  ListTriggerInstancesSecurity,
} from "../models/operations/listtriggerinstances.js";
import { unwrapAsync } from "../types/fp.js";
export type TriggersQueryData = ListTriggerInstancesResult;

export function prefetchTriggers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListTriggerInstancesRequest | undefined,
  security?: ListTriggerInstancesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildTriggersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildTriggersQuery(
  client$: GramCore,
  request?: ListTriggerInstancesRequest | undefined,
  security?: ListTriggerInstancesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<TriggersQueryData>;
} {
  return {
    queryKey: queryKeyTriggers({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function triggersQueryFn(ctx): Promise<TriggersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(triggersList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyTriggers(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "triggers", "list", parameters];
}
